import store from '~/redux/store';

const requestAssistedPurchaseVariable = async (axios, searchValue, page, limit, params = {}) => {
    const { user } = store.getState();
    const { data } = await axios.get(`/assisted-purchase-variable/company/${user.company.id}`);

    const uniqueVariables = [...new Map(data.map(variable => [variable.name, variable])).values()];

    return {
        result: uniqueVariables.map(variable => ({
            label: variable.description ?? variable.name,
            key: variable.name,
            item: variable,
        })),
    };
};

export default requestAssistedPurchaseVariable;
